import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { useTranslation } from 'react-i18next';

interface PhilosophySectionProps {
  tagline: string;
  description: string;
}

export default function PhilosophySection({ tagline, description }: PhilosophySectionProps) {
  const { t } = useTranslation();
  const { ref: refText, isVisible: visText } = useScrollReveal();
  const { ref: refImg, isVisible: visImg } = useScrollReveal();

  return (
    <section id="philosophy" className="relative py-32 bg-[#FAFAF7] overflow-hidden">
      <div className="absolute top-0 left-0 w-1/2 h-full pointer-events-none opacity-20">
        <div className="w-full h-full" style={{ background: 'radial-gradient(ellipse at top left, rgba(181,154,106,0.15) 0%, transparent 70%)' }} />
      </div>

      <div className="max-w-7xl mx-auto px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <div ref={refText} className={`reveal-left ${visText ? 'visible' : ''}`}>
          <div className="flex items-center gap-4 mb-8">
            <div className="gold-line" />
            <p className="font-sans text-[10px] tracking-[0.35em] uppercase text-[#B59A6A]">{t('philosophy.label')}</p>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#1C1C1C] leading-snug mb-10">{tagline}</h2>
          <p className="font-sans text-[15px] text-[#6B6460] leading-[2] font-light mb-12 max-w-lg">{description}</p>
          <div className="grid grid-cols-3 gap-6 pt-8 border-t border-[#E5DDD3]">
            {[
              { value: '680', unit: 'm²', label: t('philosophy.stat.area') },
              { value: '2021', unit: '', label: t('philosophy.stat.built') },
              { value: '5.8', unit: 'Mio.', label: t('philosophy.stat.price') },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="font-serif text-2xl font-medium text-[#1C1C1C]">
                  {stat.value}<span className="text-[#B59A6A] text-base ml-1">{stat.unit}</span>
                </p>
                <p className="font-sans text-[10px] tracking-widest uppercase text-[#6B6460] mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div ref={refImg} className={`img-zoom-wrap ${visImg ? 'visible' : ''} reveal-right ${visImg ? 'visible' : ''} relative`}>
          <div className="relative w-full h-[540px]">
            <img
              src="https://public.readdy.ai/ai/img_res/12b647c8f9bc25e804dfbea4b23067e3.jpg"
              alt="Interieur Philosophie"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute -bottom-4 -left-4 w-20 h-20 border-b border-l border-[#B59A6A] pointer-events-none" />
            <div className="absolute -top-4 -right-4 w-20 h-20 border-t border-r border-[#B59A6A] pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  );
}
